module.exports = __webpack_public_path__ + "img/cd.1663a822.png";